// extracted by mini-css-extract-plugin
export default {"component":"MarketOverlayHeader_component__zX99z","imgClose":"MarketOverlayHeader_imgClose__3JGbY"};